import _ from "lodash"

import { DealId, DealLineId, DealLineSkuId, SkuId } from "shared/hubrise/ids"
import { IDealLineSku } from "shared/hubrise/models"
import * as DealLineSku from "shared/hubrise/utils/DealLineSku"

import type { OperationContext } from "./types"
import { Change } from "./types"

export type DealLineSkuOperations = {
  add(dealId: DealId, dealLineId: DealLineId, skuIds: Array<SkuId>): void
  delete(dealId: DealId, dealLineId: DealLineId, dealLineSkuId: DealLineSkuId): void
  update<T extends keyof IDealLineSku>(
    dealId: DealId,
    dealLineId: DealLineId,
    dealLineSkuId: DealLineSkuId,
    fieldName: T,
    value: IDealLineSku[T],
    options?: { collapse?: boolean },
  ): void
}

export default ({ catalog, pushState }: OperationContext): DealLineSkuOperations => ({
  add(dealId, dealLineId, skuIds) {
    const newCatalog = DealLineSku.add(catalog, dealId, dealLineId, skuIds)
    pushState(newCatalog, { model: "dealLineSku", operation: "add" })
  },

  delete(dealId, dealLineId, dealLineSkuId) {
    const newCatalog = DealLineSku.doDelete(catalog, dealId, dealLineId, dealLineSkuId)
    pushState(newCatalog, { model: "dealLineSku", operation: "delete", id: dealLineSkuId })
  },

  update(dealId, dealLineId, dealLineSkuId, fieldName, value, { collapse = true } = {}) {
    const newCatalog = DealLineSku.update(catalog, dealId, dealLineId, dealLineSkuId, fieldName, value)
    const change: Change = {
      model: "dealLineSku",
      id: dealLineSkuId,
      operation: "update",
      fieldName,
    }
    pushState(newCatalog, change, (previousChange) => collapse && _.isEqual(previousChange, change))
  },
})
